export const getVehicleTitle = (brand, model, showModelName = true) => {
    if (!brand) return model || '';
    if (!showModelName || !model || brand?.toLowerCase() === model?.toLowerCase()) {
        return brand;
    }
    return `${brand} ${model}`;
};

export const getVehicleFullName = (brand, model, type) => {
    const title = getVehicleTitle(brand, model);
    return type ? `${title} ${type}` : title;
};
